import React from "react";
import { Switch, Route } from "react-router-dom";
import Layout from "./Layout"

export default () => (
  <Switch>
    <Route exact path="/summary_dashboard" component={Layout} />
  </Switch>
); 
